import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { IonModal, IonButton, IonIcon, IonGrid, IonRow, IonCol, IonImg } from '@ionic/react';
import { close, checkmark, bedOutline, star } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { MealPlans } from '../../../defines/Functions';
import CurrencyFormat from 'react-currency-format';
import axios from 'axios';
import HotelRoomTerm from './HotelRoomTerm';
import './HotelRooms.css';
import Loading from '../../Loading';
import warningSign from '../../../assets/images/warning.svg';

interface Props {
    data: any,
    item: any,
    closeHotelMap: Function,
    expireTime?: any,
    type?: string,
    hotelData?: any,
    flightData?: any,
    activeFlight?: any,
    flightHotelDefines?: any
}
const HotelRooms = (props: Props) => {
    const hotelsRooms = Constants.api.hotelsRooms;
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showHotelRoomsModal: false,
        errorMessage: '',
        hotelStay: [] as any,
        roomStay: [] as any
    });
    useEffect(() => {
        let xmlData = '<OTA_HotelAvailRQ CorrelationID="' + props.data.correlationId + '">';
        xmlData += '<AvailRequestSegments>';
        xmlData += '<AvailRequestSegment>';
        xmlData += '<HotelSearchCriteria>';
        xmlData += '<Criterion>';
        xmlData += '<HotelRef HotelCode="' + props.data.hotelCode + '"/>';
        xmlData += '<StayDateRange Start="' + props.data.startDate + '" End="' + props.data.endDate + '" />';
        xmlData += '<Address>';
        xmlData += '<CityName>' + props.data.cityName + '</CityName>';
        xmlData += '<CountryName Code="' + props.data.countryName + '"></CountryName>';
        xmlData += '</Address>';
        xmlData += '<RateRange MinRate="1" MaxRate="5" />';
        xmlData += '<Profiles>';
        xmlData += '<ProfileInfo>';
        xmlData += '<Profile>';
        xmlData += '<Customer CurrencyCode="IRR">';
        xmlData += '<CitizenCountryName Code="' + props.data.citizenCountryName + '"/>';
        xmlData += '</Customer>';
        xmlData += '</Profile>';
        xmlData += '</ProfileInfo>';
        xmlData += '</Profiles>';
        xmlData += '<RoomStayCandidates>';
        props.data.rooms.forEach((item: any) => {
            xmlData += '<RoomStayCandidate>';
            xmlData += '<GuestCounts>';
            xmlData += '<GuestCount AgeQualifyingCode="Adult" Count="' + item.adults + '" />';
            if (item.childsAges.length !== 0) {
                item.childsAges.forEach((itemChild: any) => {
                    xmlData += '<GuestCount AgeQualifyingCode="Child" Age="' + itemChild + '" Count="1" />';
                });
            }
            xmlData += '</GuestCounts>';
            xmlData += '</RoomStayCandidate>';
        });
        xmlData += '</RoomStayCandidates>';
        xmlData += '</Criterion>';
        xmlData += '</HotelSearchCriteria>';
        xmlData += '</AvailRequestSegment>';
        xmlData += '</AvailRequestSegments>';
        xmlData += '</OTA_HotelAvailRQ>';
        const getHotelRooms = async () => {
            setLoading(true);
            try {
                const results = await axios.post(hotelsRooms, xmlData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                });
                if (results.data.status === 'error') {
                    setState({ ...state, errorMessage: 'خطا در برقراری ارتباط با وب سرویس' });
                    setLoading(false);
                } else {
                    if (results.data.items.hasOwnProperty('errors')) {
                        setState({ ...state, errorMessage: 'نتیجه ای یافت نشد', roomStay: [] });
                    } else {
                        let myData = {} as any;
                        results.data.items.roomStays.roomStay.forEach((rms: any) => {
                            if (!myData[rms.roomStayGroupID]) {
                                myData[rms.roomStayGroupID] = [];
                            }
                            if (
                                rms.tpaextensions !== undefined &&
                                rms.tpaextensions.any !== undefined &&
                                rms.tpaextensions.any[0].length &&
                                rms.tpaextensions.any[0].freeTransfer !== undefined &&
                                rms.tpaextensions.any[0].freeTransfer === 'true'
                            ) {
                                rms.freeTransfer = 'دارد';
                            } else {
                                rms.freeTransfer = 'ندارد';
                            }
                            myData[rms.roomStayGroupID].push({ rms });
                        });
                        setState({ ...state, errorMessage: '', hotelStay: results.data.items.hotelStays.hotelStay, roomStay: myData });
                    }
                    setLoading(false);
                }
            } catch (error) {
                console.log(error);
                setState({ ...state, errorMessage: 'خطا در برقراری ارتباط با وب سرویس', roomStay: [] });
                setLoading(false);
            }
        }
        if (state.showHotelRoomsModal) {
            getHotelRooms();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hotelsRooms, props.data.cityName, props.data.correlationId, props.data.countryCode, props.data.countryName, props.data.endData, props.data.endDate, props.data.hotelCode, props.data.rooms, props.data.startDate, state.showHotelRoomsModal]);

    const onReserveClick = (hotelRoom: any) => {
        props.closeHotelMap(true);
        setState({ ...state, showHotelRoomsModal: false });
        let itemObj = {
            data: {},
            hotelDefines: {},
            roomStays: {},
            expireTime: ''
        }
        itemObj.data = props.item.data;
        itemObj.hotelDefines = props.item.hotelDefines;
        itemObj.roomStays = props.item.roomStays;
        itemObj.expireTime = props.expireTime;
        if (props.type !== 'flightHotel') {
            history.push({
                pathname: '/hotel/reservation',
                state: { data: props.data, item: itemObj, hotelRoom: hotelRoom }
            });
        } else {
            history.push({
                pathname: '/flightHotel/reservation',
                state: { data: props.data, item: itemObj, hotelRoom: hotelRoom, hotelData: props.hotelData, flightData: props.flightData, flightHotelDefines: props.flightHotelDefines, activeFlight: props.activeFlight }
            });
        }
    }
    const onCloseModal = () => {
        setState({ ...state, showHotelRoomsModal: false });
    }
    return (
        <>
            <IonModal isOpen={state.showHotelRoomsModal} onDidDismiss={onCloseModal} mode="ios" cssClass="hotel-rooms-modal">
                <div className="hotel-rooms-modal-content">
                    <h3 className="hotel-rooms-modal-title">
                        لیست اتاق ها
                        <IonIcon icon={close} onClick={onCloseModal} />
                    </h3>
                    {!loading ?
                        <div className="hotel-rooms-modal-items">
                            {state.errorMessage.trim().length !== 0 ?
                                <div className="box-error">
                                    <IonImg src={warningSign} />
                                    <p>{state.errorMessage}</p>
                                </div>
                                :
                                <IonGrid>
                                    {Object.values(state.roomStay).map((hotelRoom: any, index: number) =>
                                        <IonRow className="room-item" key={"index" + index}>
                                            <IonCol size="4" className="">
                                                <div>
                                                    {hotelRoom.map((hrms: any, hrmsIndex: number) =>
                                                        <div key={"hrms" + hrmsIndex}>
                                                            {hrmsIndex === 0 &&
                                                                <b>اتاق</b>
                                                            }
                                                            <span>
                                                                {hrms.rms.roomTypes.roomType[0].tpaextensions !== undefined && hrms.rms.roomTypes.roomType[0].tpaextensions.any[0].persianRoomType ?
                                                                    hrms.rms.roomTypes.roomType[0].tpaextensions.any[0].persianRoomType
                                                                    :
                                                                    hrms.rms.roomTypes.roomType[0].roomType
                                                                }
                                                            </span>
                                                        </div>

                                                    )}
                                                </div>
                                            </IonCol>
                                            <IonCol size="4">
                                                {hotelRoom.map((hrms: any, hrmsIndex: number) =>
                                                    <div key={"hrms" + hrmsIndex}>
                                                        {hrmsIndex === 0 &&
                                                            <b>خدمات</b>
                                                        }
                                                        <span>{MealPlans(hrms.rms.roomRates.roomRate[0].ratePlanID)}</span>
                                                    </div>
                                                )}
                                            </IonCol>
                                            <IonCol size="4">
                                                {hotelRoom.map((hrms: any, hrmsIndex: number) =>
                                                    <div key={"hrms" + hrmsIndex}>
                                                        {hrmsIndex === 0 &&
                                                            <b>ترانسفر رایگان</b>
                                                        }
                                                        <span>{hrms.rms.freeTransfer}</span>
                                                    </div>
                                                )}
                                            </IonCol>
                                            {state.hotelStay[0].basicPropertyInfo.hotelAmenity.length !== 0 &&
                                                <IonCol size="12" className="hotel-amenity">
                                                    <b>امکانات هتل : </b>
                                                    {state.hotelStay[0].basicPropertyInfo.hotelAmenity.map((amenity: any, amenityIndex: number) =>
                                                        <span key={"index" + amenityIndex}>
                                                            <IonIcon icon={star} />
                                                            {amenity.Code}
                                                        </span>
                                                    )}
                                                </IonCol>
                                            }
                                            <IonCol size="12" className="room-price-col">
                                                <div className="room-price">
                                                    {hotelRoom.map((_: any, hrmsIndex: number) =>
                                                        hrmsIndex === 0 &&
                                                        <span key={"index" + hrmsIndex}>
                                                            مجموع {hotelRoom.length} اتاق :
                                                        </span>
                                                    )}
                                                    {hotelRoom[0].rms.basicPropertyInfo.hasOwnProperty('vendorMessages') &&
                                                        hotelRoom[0].rms.basicPropertyInfo.vendorMessages.vendorMessage.map((vm: any, vmIndex: number) =>
                                                            vm.infoType === 'Discount' && vm.title !== 0 &&
                                                            <span className="discount">
                                                                <CurrencyFormat value={vm.title} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                                            </span>
                                                        )
                                                    }
                                                    <b>
                                                        {props.type !== 'flightHotel' ?
                                                            <CurrencyFormat value={hotelRoom[0].rms.total.amountAfterTax} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                                            :
                                                            <CurrencyFormat value={hotelRoom[0].rms.total.amountAfterTax + props.activeFlight.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                                        }
                                                    </b>
                                                </div>
                                            </IonCol>
                                            <IonCol size="6">
                                                <HotelRoomTerm data={hotelRoom[0].rms.reference} dataDefines={props.item.hotelDefines} />
                                            </IonCol>
                                            <IonCol size="6">
                                                <IonButton color="warning" expand="block" onClick={() => onReserveClick(hotelRoom)}>
                                                    رزرو اتاق
                                                    <IonIcon icon={bedOutline} />
                                                </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    )}
                                </IonGrid>
                            }
                        </div>
                        :
                        <Loading />
                    }
                </div>
            </IonModal>
            <IonButton color="warning" onClick={() => setState({ ...state, showHotelRoomsModal: true })}>
                انتخاب اتاق
                <IonIcon icon={checkmark} />
            </IonButton>
        </>
    );
};
export default HotelRooms;